import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FiMenu, FiX } from "react-icons/fi"; // Import icons for the menu
import ContactUs from "./ContactUs";
import { useNavigate } from "react-router-dom";
import Modal from "../Modal";

const Navbar = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["whyus", "learners", "overviews", "testimonials", "blog", "faq"];
      let currentSection = "";

      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top >= 0 && rect.top <= window.innerHeight / 3) {
            currentSection = section;
            break;
          }
        }
      }
      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow-md py-4 px-6 md:px-10 flex justify-between items-center z-50">
      {/* Logo */}
      <div className="text-2xl font-bold text-orange-500" onClick={() => navigate("/smikrecruit")}>
        <span className="text-orange-500">Smik</span>
        <span className="text-blue-500">learn</span>
      </div>

      {/* Navigation Links (Visible on Medium Screens & Above) */}
      <ul className="hidden md:flex space-x-6 text-gray-600 font-semibold">
        {[
          { id: "whyus", label: "Why us" },
          { id: "learners", label: "Learners’ Profile" },
          { id: "overviews", label: "Overview" },
          { id: "testimonials", label: "Testimonials" },
          { id: "blog", label: "Blog" },
          { id: "faq", label: "FAQ" },
        ].map(({ id, label }) => (
          <li key={id}>
            <Link
              to={id}
              smooth={true}
              duration={500}
              className={`cursor-pointer px-4 py-2 text-lg transition-all duration-300 ${activeSection === id ? "text-blue-500 border-b-2 border-blue-500" : "text-gray-600 hover:text-blue-500"
                }`}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>

      {/* Menu Button (For Mobile) */}
      <button
        className="md:hidden text-2xl text-gray-600"
        onClick={() => setIsMenuOpen(true)}
      >
        <FiMenu />
      </button>

      {/* Sidebar Menu (For Small Screens) */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ${isMenuOpen ? "translate-x-0" : "-translate-x-full"
          }`}
      >
        {/* Close Button */}
        <button
          className="!absolute top-4 right-4 text-2xl text-gray-600"
          onClick={() => setIsMenuOpen(false)}
        >
          <FiX />
        </button>

        {/* Sidebar Items */}
        <ul className="flex flex-col space-y-4 mt-16 px-6 text-gray-600 font-semibold">
          {[
            { id: "whyus", label: "Why us" },
            { id: "learners", label: "Learners’ Profile" },
            { id: "overviews", label: "Overview" },
            { id: "testimonials", label: "Testimonials" },
            { id: "blog", label: "Blog" },
            { id: "faq", label: "FAQ" },
          ].map(({ id, label }) => (
            <li key={id}>
              <Link
                to={id}
                smooth={true}
                duration={500}
                onClick={() => setIsMenuOpen(false)} // Close menu on click
                className={`cursor-pointer block px-4 py-2 text-lg transition-all duration-300 ${activeSection === id ? "text-blue-500 border-l-4 border-blue-500 pl-2" : "text-gray-600"
                  }`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Start Hiring Button */}
      <button className="hidden md:block bg-blue-500 text-white px-4 py-2 rounded-md font-semibold" onClick={openModal}>
        Start Hiring
      </button>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <div className="flex items-center justify-content-between bg-[#0e63e2] rounded-md mb-2 py-3">
            <p className="text-white font-bold text-xl pl-3">Contact Us</p>
          </div>
          <div className="bg-white w-[100%] h-[88%] rounded-lg shadow-lg relative overflow-auto">
            <ContactUs />
          </div>
        </Modal>
      )}
    </nav>
  );
};

export default Navbar;
